import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { User } from '../../types';

interface UserState {
  currentUser: User | null;
  isAuthenticated: boolean;
  token: string | null;
}

const initialState: UserState = {
  currentUser: null,
  isAuthenticated: false,
  token: null
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    loadUser: (state, action: PayloadAction<User>) => {
      state.isAuthenticated = true;
      state.currentUser = action.payload;
    },
    noUser: state => {
      state.isAuthenticated = false;
      state.currentUser = null;
    },
    loginUser: (state, action: PayloadAction<User>) => {
      state.isAuthenticated = true;
      state.currentUser = action.payload;
    },
    logoutUser: state => {
      state.isAuthenticated = false;
      state.currentUser = null;
    },
    updateToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
    }
  }
});

export const { loadUser, loginUser, noUser, logoutUser, updateToken } = userSlice.actions;
export default userSlice.reducer;
